import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

document.querySelectorAll('.element-partners').forEach((el) => {
  const container = el.querySelector('.swiper')
  const showAllToggles = el.querySelectorAll('.show-all-toggle')

  const swiper = new Swiper(container, {
    modules: [A11y, Navigation],
    slidesPerView: 1,
    allowTouchMove: false,
    spaceBetween: 24,
    navigation: {
      nextEl: el.querySelector('.slider-button-next'),
      prevEl: el.querySelector('.slider-button-prev'),
    },
    loop: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 'auto',
        spaceBetween: 36,
      },
    },
  })

  if (showAllToggles.length) {
    showAllToggles.forEach((button) => {
      button.addEventListener('click', () => {
        el.classList.toggle('is-show-all')

        if (el.classList.contains('is-show-all')) {
          swiper.slideTo(0, 0)
          swiper.disable()
        } else {
          el.classList.add('is-enabling')
          swiper.enable()

          setTimeout(() => {
            el.classList.remove('is-enabling')
          }, 300)
        }
      })
    })
  }
})
